export const paymentSettingConstants = {
   ADD_PAYSETTING_REQUEST:       'ADD_PAYSETTING_REQUEST',
   ADD_PAYSETTING_SUCCESS:       'ADD_PAYSETTING_SUCCESS',
   ADD_PAYSETTING_FAILURE:       'ADD_PAYSETTING_FAILURE',
   GET_PAYSETTING_REQUEST:       'GET_PAYSETTING_REQUEST',
   GET_PAYSETTING_SUCCESS:       'GET_PAYSETTING_SUCCESS',
   GET_PAYSETTING_FAILURE:       'GET_PAYSETTING_FAILURE',
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/paymentSettingConstants.js